<div class="pie-wrapper">
  <ngx-charts-pie-grid [view]="view" [scheme]="'vivid'" [results]="modelWiseScoresData" [animations]="false" (select)="onSelect($event)">
  </ngx-charts-pie-grid>
</div>